/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DeleteUsersIdPathParams, DeleteUsersId200, DeleteUsersId400, DeleteUsersId403, DeleteUsersIdMutationResponse } from '../entities/DeleteUsersId'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

export const deleteUsersIdPathParamsSchema = z.object({
  id: z.string().describe('ID пользователя'),
}) as unknown as ToZod<DeleteUsersIdPathParams>

/**
 * @description OK
 */
export const deleteUsersId200Schema = z.any() as unknown as ToZod<DeleteUsersId200>

/**
 * @description Bad Request
 */
export const deleteUsersId400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<DeleteUsersId400>

/**
 * @description Forbidden
 */
export const deleteUsersId403Schema = z.any() as unknown as ToZod<DeleteUsersId403>

export const deleteUsersIdMutationResponseSchema = z.lazy(() => deleteUsersId200Schema) as unknown as ToZod<DeleteUsersIdMutationResponse>